import { DataType } from '@/util/index'
const LIST_TABLE_HEADER = {
  searchCustomerDialogTable: [
    {
      text: 'Action',
      value: '',
      sortable: false,
      width: '100px'
    },
    {
      text: 'Loan #',
      value: 'loanNo',
      width: '130px'
    },
    {
      text: 'Loan Status',
      value: 'loanStatus',
      width: '180px'
    },
    {
      text: 'Subsequent Advance Status',
      value: 'slaveLoanStatus',
      width: '205px'
    },
    {
      text: 'Name',
      value: 'fullName',
      width: '150px'
    },
    {
      text: 'SSN',
      value: 'ssn',
      width: '100px'
    },
    {
      text: 'Email',
      value: 'email',
      width: '100px'
    },
    {
      text: 'Cell Phone',
      value: 'cellPhone',
      width: '140px'
    },
    {
      text: 'Account #',
      value: 'accountNo',
      width: '110px'
    }
  ],

  preOriginationWorkbenchTable: [
    {
      text: 'Action',
      value: '',
      sortable: false
    },
    {
      text: 'Loan #',
      value: 'loanNo'
    },
    {
      text: 'Name',
      value: 'fullName'
    },
    {
      text: 'Approved Amount',
      value: 'approvedAmount',
      type: 'currency'
    },
    {
      text: 'Status',
      value: 'loanStatus'
    },
    {
      text: 'Created At',
      value: 'createdAt',
      type: 'datetime'
    }
  ],

  toCorrectorDialog: [
    { text: '#', sortable: false },
    { text: 'Category', value: 'category', sortable: false },
    { text: 'Sub-Category', value: 'subCategory', sortable: false },
    { text: 'Notes', value: 'notes', sortable: false },
    { text: 'Actions', value: 'action', sortable: false, align: 'center' }
  ],

  BankRecordsMoreDetailsHeader: [
    { label: 'VOB', template: '{vob}', fieldKey: 'vob', options: { vob: DataType.VoB } },
    { label: 'Date', template: '{payrollDate}', fieldKey: 'payrollDate', format: 'date' },
    { label: 'Payroll Type', template: '{payrollType}', fieldKey: 'payrollType', options: { payrollType: DataType.PayrollType } },
    { label: 'Amount', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'Balance', template: '{balance}', fieldKey: 'balance', format: 'currency' }
  ],

  CorrectionReasonsMoreDetailsHeader: [
    {
      text: 'Category',
      value: 'category',
      sortable: false
    },
    {
      text: 'Sub-Category',
      value: 'subCategory',
      sortable: false
    },
    {
      text: 'Notes',
      value: 'notes',
      sortable: false
    }
  ],

  AuditRecordMoreDetailsHeader: [
    { label: 'SECTION', template: '{primaryCode}', fieldKey: 'primaryCode', options: { primaryCode: DataType.AuditSectionKey } },
    { label: 'AUDIT REASON', template: '{secondaryCode}', fieldKey: 'secondaryCode', options: { secondaryCode: DataType.AuditReasonEnum } },
    { label: 'STATUS', template: '{status}', fieldKey: 'status', options: { status: DataType.AuditStatusEnum } }
  ],

  PaymentInstallmentMoreDetailsHeader: [
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'DATE', template: '{transactionDate}', fieldKey: 'transactionDate', format: 'date' },
    { label: 'MODE', template: '{transactionMode}', fieldKey: 'transactionMode', options: { transactionMode: DataType.TransactionMode } },
    { label: 'TYPE', template: '{transactionType}', fieldKey: 'transactionType', options: { transactionType: DataType.TransactionTypeOptions } },
    { label: 'CHANGE TYPE', template: '{changeType}', fieldKey: 'changeType', options: { changeType: DataType.ChangeType } },
    { label: 'STATUS', template: '{transactionStatus}', fieldKey: 'transactionStatus', options: { transactionStatus: DataType.TransactionStatusEnum } },
    { label: 'AMOUNT', template: '{transactionAmount}', fieldKey: 'transactionAmount', format: 'currency' },
    { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'financeFee', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' },
    { label: 'ADDITIONAL FEE', template: '{additionalFee}', fieldKey: 'additionalFee', format: 'currency' },
    { label: 'LATE FEE', template: '{lateFee}', fieldKey: 'lateFee', format: 'currency' },
    { label: 'NSF FEE', template: '{nsfFee}', fieldKey: 'nsfFee', format: 'currency' },
    { label: 'BANK FEE', template: '{bankFee}', fieldKey: 'bankFee', format: 'currency' },
    { label: 'RETURN CODE', template: '{returnCode}', fieldKey: 'returnCode' },
    { label: 'RETURN DATE', template: '{returnedAt}', fieldKey: 'returnedAt', format: 'date' },
    { label: 'TRANSACTION #', template: '{transactionNo}', fieldKey: 'transactionNo' }
  ],

  PaymentFeeMoreDetailsHeader: [
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'LOAN ID', template: '{loanId}', fieldKey: 'loanId' },
    { label: 'TYPE', template: '{type}', fieldKey: 'type', options: { type: DataType.PaymentFeeTypeEnum } },
    { label: 'AMOUNT', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'TRANSFERRED AMOUNT', template: '{transferredAmount}', fieldKey: 'transferredAmount', format: 'currency' },
    { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'interest', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' },
    { label: 'ADDITIONAL FEE', template: '{additionalFee}', fieldKey: 'additionalFee', format: 'currency' },
    { label: 'BANK FEE', template: '{bankFee}', fieldKey: 'bankFee', format: 'currency' },
    { label: 'LATE FEE', template: '{lateFee}', fieldKey: 'lateFee', format: 'currency' },
    { label: 'NSF FEE', template: '{nsfFee}', fieldKey: 'nsfFee', format: 'currency' }
  ],

  CancelChangesHeader: [
    { text: 'Change Type', value: 'changeType', sortable: false },
    { text: 'Operated At', value: 'operateAt', sortable: false },
    { text: 'Operated By', value: 'operateBy', sortable: false },
    { text: 'Details', value: 'details', sortable: false }
  ],

  TribeReviewBatchApproveHeader: [
    {
      text: 'Loan #',
      value: 'loanNo',
      sortable: false
    },
    {
      text: 'Name',
      value: 'name',
      sortable: false
    },
    {
      text: 'Approved Amount',
      value: 'approvedAmount',
      sortable: false
    },
    {
      text: 'Disbursement Date',
      value: 'effectiveDate',
      sortable: false
    },
    {
      text: 'Received At',
      value: 'enteredAt',
      sortable: false
    },
    {
      text: 'Score',
      value: 'totalScore',
      sortable: false
    }
  ],

  ExportLoanQueueHeader: [
    {
      text: 'Loan #',
      value: 'loanNo',
      sortable: false
    },
    {
      text: 'Paid off Date',
      value: 'paidOffDate',
      sortable: false
    },
    {
      text: 'Name of the Customer',
      value: 'name',
      sortable: false
    },
    {
      text: 'Program',
      value: 'program',
      sortable: false
    }
  ],

  ExportUnderWriterHeader: [
    {
      text: 'Loan #',
      value: 'loanNo',
      sortable: false
    },
    {
      text: 'Disbursement Date',
      value: 'effectiveDate',
      sortable: false
    },
    {
      text: 'Name of the Customer',
      value: 'name',
      sortable: false
    },
    {
      text: 'Program',
      value: 'program',
      sortable: false
    }
  ],

  ThirdPartySendEmailHeader: [
    {
      text: 'Loan #',
      value: 'loanNo',
      sortable: false
    },
    {
      text: 'Full Name',
      value: 'fullName',
      sortable: false
    },
    {
      text: 'Payroll Frequency',
      value: 'payrollFrequency',
      sortable: false
    },
    {
      text: 'Principal',
      value: 'principal',
      sortable: false
    },
    {
      text: 'Finance Fee',
      value: 'interest',
      sortable: false
    },
    {
      text: 'Late Fee',
      value: 'lateFee',
      sortable: false
    },
    {
      text: 'NSF Fee',
      value: 'nsfFee',
      sortable: false
    },
    {
      text: 'Unpaid Fee',
      value: 'unpaidFee',
      sortable: false
    },
    {
      text: 'Total Balance',
      value: 'amount',
      sortable: false
    },
    {
      text: 'To Collection Date',
      value: 'moveToLcs',
      sortable: false
    },
    {
      text: 'Day in Collection',
      value: 'inCollectedDay',
      sortable: false
    },
    {
      text: 'Last Return Code',
      value: 'lastReturnedCode',
      sortable: false
    },
    {
      text: 'Last Return Date',
      value: 'lastReturnedDate',
      sortable: false
    }
  ],

  ThirdPartyPayDitHeader: [
    {
      text: 'Loan #',
      value: 'loanNo',
      sortable: false
    },
    {
      text: 'Full Name',
      value: 'fullName',
      sortable: false
    },
    {
      text: 'Principal',
      value: 'principal',
      sortable: false
    },
    {
      text: 'Finance Fee',
      value: 'interest',
      sortable: false
    },
    {
      text: 'Late Fee',
      value: 'lateFee',
      sortable: false
    },
    {
      text: 'NSF Fee',
      value: 'nsfFee',
      sortable: false
    },
    {
      text: 'Unpaid Fee',
      value: 'unpaidFee',
      sortable: false
    },
    {
      text: 'Total Balance',
      value: 'amount',
      sortable: false
    },
    {
      text: 'To Collection Date',
      value: 'moveToLcs',
      sortable: false
    },
    {
      text: 'Day in Collection',
      value: 'inCollectedDay',
      sortable: false
    }
  ],

  WORK_QUEUE_TABLE_HEADERS: [
    { text: 'Loan#', value: 'loanDetails', sortable: false, align: 'start' },
    { text: 'Action', value: 'Action', sortable: false },
    { text: 'Features', value: 'features', sortable: false },
    { text: 'Disbursement Date', value: 'effective_date', sortable: false },
    { text: 'Amount Financed', value: 'loan_amount', sortable: false },
    { text: 'Initial Advance', value: 'approved_amount', sortable: false },
    { text: 'Updated At', value: 'updated_at', sortable: false },
    { text: 'Entered At', value: 'entered_at', sortable: false },
    { text: 'Submitted At', value: 'submitted_at', sortable: false },
    { text: 'Submitted By', value: 'submitted_by', sortable: false },
    { text: 'Signed At', value: 'signed_at', sortable: false },
    { text: 'Locked By', value: 'locked_by', sortable: false }
  ],
  WORK_QUEUE_UNDERWRITER_TABLE_HEADERS: [
    { text: 'Loan#', value: 'loanDetails', sortable: false, align: 'start' },
    { text: 'Action', value: 'Action', sortable: false },
    { text: 'Features', value: 'features', sortable: false },
    { text: 'Disbursement Mode', value: 'default_disbursement_mode', sortable: false },
    { text: 'Disbursement Date', value: 'effective_date', sortable: false },
    { text: 'Submitted At', value: 'submitted_at', sortable: false },
    { text: 'Previous AR', value: 'audited_by', sortable: false },
    { text: 'Locked By', value: 'locked_by', sortable: false }
  ],
  WORK_QUEUE_UNDERWRITER_AMOUNT_TABLE_HEADERS: [
    { text: 'Loan#', value: 'loanDetails', sortable: false, align: 'start' },
    { text: 'Action', value: 'Action', sortable: false },
    { text: 'Features', value: 'features', sortable: false },
    { text: 'Disbursement Mode', value: 'default_disbursement_mode', sortable: false },
    { text: 'Disbursement Date', value: 'effective_date', sortable: false },
    { text: 'Amount Financed', value: 'loan_amount', sortable: false },
    { text: 'Initial Advance', value: 'approved_amount', sortable: false },
    { text: 'Submitted At', value: 'submitted_at', sortable: false },
    { text: 'Previous AR', value: 'audited_by', sortable: false },
    { text: 'Locked By', value: 'locked_by', sortable: false }
  ],
  WORK_QUEUE_TABLE_HEADERS_IN_LCS: [
    { text: 'Loan#', value: 'loanDetails', sortable: false, align: 'start' },
    { text: 'Action', value: 'Action', sortable: false },
    { text: 'Features', value: 'features', sortable: false },
    { text: 'Disbursement Date', value: 'effective_date', sortable: false },
    { text: 'Amount Financed', value: 'loan_amount', sortable: false },
    { text: 'Initial Advance', value: 'approved_amount', sortable: false },
    { text: 'Updated At', value: 'updated_at', sortable: false },
    { text: 'Entered At', value: 'entered_at', sortable: false },
    { text: 'Submitted At', value: 'submitted_at', sortable: false },
    { text: 'Submitted By', value: 'submitted_by', sortable: false },
    { text: 'Signed At', value: 'signed_at', sortable: false },
    { text: 'Locked By', value: 'locked_by', sortable: false },
    { text: 'Days Old', value: 'days_old', sortable: false }
  ],
  SUMMARY_HEADER: [
    {
      text: 'Description',
      value: '',
      sortable: false
    },
    {
      text: 'Code',
      value: '',
      sortable: false
    },
    {
      text: 'Transactions',
      value: '',
      sortable: false
    },
    {
      text: 'Total',
      value: '',
      sortable: false
    },
    {
      text: 'Transactions Last Month',
      value: '',
      sortable: false
    },
    {
      text: 'Total Last Month',
      value: '',
      sortable: false
    }
  ],
  TRANSACTION_HEADER: [
    {
      text: 'Date',
      value: 'transactionDate',
      sortable: false
    },
    {
      text: '',
      value: 'typeCodes',
      sortable: false
    },
    {
      text: 'Amount',
      value: 'amount',
      sortable: false
    },
    {
      text: 'Balance',
      value: 'runningBalance',
      sortable: false
    },
    {
      text: 'Status',
      value: 'status',
      sortable: false
    },
    {
      text: 'Category',
      value: 'category',
      sortable: false
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false
    }
  ],
  TRANSACTION_HEADER_CHIRP: [
    {
      text: 'Date',
      value: 'transactionDate',
      sortable: false
    },
    {
      text: 'Code',
      value: 'typeCodes',
      sortable: false
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false
    },
    {
      text: 'Category',
      value: 'category',
      sortable: false
    },
    {
      text: 'Status',
      value: 'status',
      sortable: false
    },
    {
      text: 'Amount',
      value: 'amount',
      sortable: false
    },
    {
      text: 'Balance',
      value: 'balance',
      sortable: false
    }
  ],
  TRANSACTION_HEADER_V4: [
    {
      text: 'Date',
      value: 'transactionDate',
      sortable: false
    },
    {
      text: '',
      value: 'categoryCode',
      sortable: false
    },
    {
      text: 'Amount',
      value: 'amount',
      sortable: false
    },
    {
      text: 'Balance',
      value: 'balance',
      sortable: false
    },
    {
      text: 'Status',
      value: 'status',
      sortable: false
    },
    {
      text: 'Category',
      value: 'category',
      sortable: false
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false
    }
  ],
  COLLECTION_MANAGEMENT_HEADER: [
    {
      text: 'Employee Name',
      value: 'fullName',
      sortable: false
    },
    {
      text: 'Collection',
      value: 'count',
      sortable: false
    },
    {
      text: 'Action',
      value: 'action',
      sortable: false
    }
  ],
  REASSIGN_COLLECTION_HEADER: {
    LOAN: [
      {
        text: 'Loan #',
        value: 'loanNo',
        sortable: false
      }
    ],
    EMPLOYEE: [
      {
        text: 'Employee No',
        value: 'employeeNo',
        sortable: false
      },
      {
        text: 'Employee Name',
        value: 'employeeName',
        sortable: false
      }
    ]
  },
  DOWNLOAD_FILE_HEADER: [
    {
      text: 'File Name',
      value: 'fileName',
      sortable: false
    },
    {
      text: 'Created At',
      value: 'transactionDate',
      sortable: false
    },
    {
      text: 'Operated By',
      value: 'operatedBy',
      sortable: false
    },
    {
      text: 'Action',
      value: 'action',
      sortable: false
    }
  ]
}

export { LIST_TABLE_HEADER }
